import { useUserStore } from '@/store/user';
import { DEBUGC } from '@/util';


/** Class for setting up a user dependent data store (i.e. must reload data, when a new user logs in) */
export class UserDependentStore {

    private _userStore = useUserStore()
    private _currentUser: string | undefined
    constructor(refresh: () => void, reset: () => void) {
        const userStore = this._userStore
        const currentUser = userStore.userData?.currentUser

        if (currentUser) {
            this._currentUser = currentUser
            refresh()
        }

        userStore.$subscribe((mutation, state) => {
            const newUser = state._userData?.currentUser

            if (this._currentUser != newUser) {
                DEBUGC('UserDependentStore: User has changed', 'orange')
                reset()

                if (newUser) {
                    refresh()
                }

                this._currentUser = newUser
            }
        })
    }
}